/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate a DNA or RNA sequence into a protein using the standard genetic code.`)
};

const es_translate_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduce una secuencia de ADN o ARN en una proteína usando el código genético estándar.`)
};

const de_translate_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzen Sie eine DNA- oder RNA-Sequenz mithilfe des Standard-genetischen Codes in ein Protein.`)
};

const nl_translate_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertaal een DNA- of RNA-sequentie naar een eiwit met de standaard genetische code.`)
};

const fr_translate_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduisez une séquence d'ADN ou d'ARN en protéine à l'aide du code génétique standard.`)
};

const it_translate_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduce una sequenza di DNA o RNA in una proteina usando il codice genetico standard.`)
};

const pt_br2_translate_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduza uma sequência de DNA ou RNA em uma proteína usando o código genético padrão.`)
};

const pt_translate_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduza uma sequência de ADN ou ARN numa proteína usando o código genético padrão.`)
};

const ja_translate_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準遺伝暗号を使ってDNAまたはRNA配列をタンパク質に翻訳します。`)
};

const zh_translate_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用标准遗传密码将 DNA 或 RNA 序列翻译为蛋白质。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_tool_description", locale)
	if (locale === "en") return en_translate_tool_description(inputs)
	if (locale === "es") return es_translate_tool_description(inputs)
	if (locale === "de") return de_translate_tool_description(inputs)
	if (locale === "nl") return nl_translate_tool_description(inputs)
	if (locale === "fr") return fr_translate_tool_description(inputs)
	if (locale === "it") return it_translate_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_translate_tool_description(inputs)
	if (locale === "pt") return pt_translate_tool_description(inputs)
	if (locale === "ja") return ja_translate_tool_description(inputs)
	return zh_translate_tool_description(inputs)
};